import { themeStyle } from '@repo/ui/theming';
import { buildWebsiteUrl } from '@repo/utils/url';

import { TosParagraph } from '../../SubscriptionModal/VariantFlows/styles';

/**
 * This component displays a confirmation message that includes links to the Terms of Use and Privacy Policy.
 * It is typically used in subscription-related flows to ensure that users acknowledge and agree to the terms and policies before proceeding.
 */
const Confirmations: React.FC = () => {
  return (
    <TosParagraph color={themeStyle.varInkMedium}>
      By continuing you agree to the{' '}
      <a href={buildWebsiteUrl('/terms')} rel="noreferrer" target="_blank">
        Terms of Use
      </a>{' '}
      and confirm you have read our{' '}
      <a href={buildWebsiteUrl('/privacy')} rel="noreferrer" target="_blank">
        Privacy Policy
      </a>
      .
    </TosParagraph>
  );
};

export default Confirmations;
